import type CK from '~/types/contentking';

import {
	useAccountCustomerTypeQuery,
} from './useAccountCustomerType.gql';

import useAccountPropertiesQuery from '~/hooks/useAccountPropertiesQuery';



function useAccountCustomerType(accountId: CK.AccountId | null) {
	const { data } = useAccountPropertiesQuery(
		useAccountCustomerTypeQuery,
		accountId,
	);

	return data?.account?.customerType ?? null;
}



export default useAccountCustomerType;
